import React from "react";

import { HvContainer, HvEmptyState } from "@hitachivantara/uikit-react-core";
import { Info } from "@hitachivantara/uikit-react-icons";

import Header from "components/layout/Header";

import useStyles from "./styles";

const NotAllowed: React.FC = () => {
  const classes = useStyles();

  return (
    <>
      <Header />
      <HvContainer className={classes.container}>
        <HvEmptyState
          style={{ width: "initial", height: "initial" }}
          title="Access Denied"
          message="You do not have permission to view this page."
          icon={<Info />}
        />
      </HvContainer>
    </>
  );
};

export default NotAllowed;
